import { Paper } from "@material-ui/core";
import { useFormik } from "formik";
import { useState } from "react";

import datetimeHelper from "../../../helper/datetime-helper";
import SearchBar from "./SearchBar";
import TableReportChargeTelecom from "./TableReportChargeTelecom";

// TODO chưa call api BE
const TelecomChargeReport = () => {
  const [filter, setFilter] = useState(null);

  const handleSearch = (searchValues) => {
    const callType =
      searchValues.callType === "all" ? null : searchValues.callType;
    const subOrg = searchValues.subOrg?.code;
    const callOutPhones =
      searchValues.phoneNumbers.indexOf("all") !== -1
        ? null
        : searchValues.phoneNumbers;
    const startDayOfMonth = new Date(
      searchValues.month.getFullYear(),
      searchValues.month.getMonth(),
      1
    );
    const endDayOfMonth = new Date(
      searchValues.month.getFullYear(),
      searchValues.month.getMonth() + 1,
      0
    );
    const startedAt = {
      gte: datetimeHelper.toFormat(startDayOfMonth, "YYYY-MM-DD startDay"),
      lte: datetimeHelper.toFormat(endDayOfMonth, "YYYY-MM-DD endDay"),
    };

    const where = {
      startedAt,
      ...(subOrg && { subOrg: [subOrg] }),
      ...(callOutPhones && { from: { inq: callOutPhones } }),
      ...(callType && { callType }),
    };
    setFilter({
      where,
    });
  };

  const searchForm = useFormik({
    initialValues: {
      subOrg: null,
      month: new Date(),
      callType: "all",
      phoneNumbers: ["all"],
    },
    onSubmit: handleSearch,
  });

  const handleExportFile = () => {};

  return (
    <>
      <Paper style={{ color: "black", padding: 16, marginBottom: 16 }}>
        <SearchBar searchForm={searchForm} onClickExport={handleExportFile} />
      </Paper>
      {filter && (
        <TableReportChargeTelecom
          callType={searchForm.values.callType}
          reportChargeTelecomFilter={filter}
        />
      )}
    </>
  );
};

export default TelecomChargeReport;
